import {
  Flex,
  Icons,
  Tooltip,
} from "@components/index";

import TimesFragment from "@fragments/Times.fragment";
import StatusFragment from "@fragments/Status.fragment";
import { useDetailsContext } from "@pages/Dashboard/contexts/Details.context";
import { useCardVariant } from "@pages/Dashboard/hooks/useCardVariant";

import styles from "./CardEvent.module.scss";

interface CardEventProps {
  event: Sentinel.Timeline.StatusTimelineObjectResponse,
};

const CardEvent: React.FC<CardEventProps> = ({ event }) => {
  const variant = useCardVariant(event.status);
  const { onOpen } = useDetailsContext();

  return (
    <Flex.Col
      gap="8px"
      alignItems="stretch"
      justifyContent="space-around"
      className={`${styles.card} card border-${variant}`}>
      <Flex.Row gap="10px" alignItems="start" justifyContent="space-between">
        <Tooltip description={event.displayName} position="top" showArrow>
          <span className="text text--md text--neutral--600 limited limited--2 bold">
            {event.displayName}
          </span>
        </Tooltip>

        <Icons icon="report" className="hand" onClick={() => onOpen(event as Sentinel.Timeline.Event)} />
      </Flex.Row>

      <TimesFragment
        gapCol="8px"
        gapRow="5px"
        plannedExecutionStart={event.plannedExecutionStart}
        plannedExecutionEnd={event.plannedExecutionEnd}
        executionStart={event.executionStart}
        executionEnd={event.executionEnd} />

      <Flex.Row justifyContent="end">
        <StatusFragment status={event?.status} plannedExecutionStart={event?.plannedExecutionStart} />
      </Flex.Row>
    </Flex.Col>
  );
}

export default CardEvent;